module.exports = __webpack_public_path__ + "img/goBack_btn_black.5cdb217a.svg";